import { ActivatedRouteSnapshot } from '@angular/router';
import { submissionAdminTokenizer } from '../store';
import { WcgTableUtilsService } from '@shared/services/wcg-table-utils.service';
import { CONFIGURE_DEFAULT_PARAMS } from '@data-access/downloads-exports';
import { inject } from '@angular/core';

export const submissionAdminResolver = (route: ActivatedRouteSnapshot) => {
  const _submissionAdminTokenizer = submissionAdminTokenizer();
  const _wcgTableUtils = inject(WcgTableUtilsService);
  let _params = _wcgTableUtils.generateTableQueryParams(
    CONFIGURE_DEFAULT_PARAMS(route),
  );
  _params = _params.append('page_size', '10');
  _submissionAdminTokenizer.loadIrisRoutingGroups();
  _submissionAdminTokenizer.loadWorkspaceSubTypes(_params);
  return !!_submissionAdminTokenizer.$workspaceSubTypes();
};
